var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLawsatSymbolWithGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lawsat Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7125 21.125C75.5461 21.125 80.275 16.3961 80.275 10.5625C80.275 4.72888 75.5461 0 69.7125 0C63.8789 0 59.15 4.72888 59.15 10.5625C59.15 16.3961 63.8789 21.125 69.7125 21.125Z",
    fill: "url(#paint0_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.275 40.1375C80.275 45.9711 75.5461 50.7 69.7125 50.7C63.8789 50.7 59.15 45.9711 59.15 40.1375C59.15 34.3039 63.8789 29.575 69.7125 29.575C75.5461 29.575 80.275 34.3039 80.275 40.1375Z",
    fill: "url(#paint1_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 109.85C16.3961 109.85 21.125 105.121 21.125 99.2875C21.125 93.4539 16.3961 88.725 10.5625 88.725C4.72888 88.725 0 93.4539 0 99.2875C0 105.121 4.72888 109.85 10.5625 109.85Z",
    fill: "url(#paint2_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7125 109.85C75.5461 109.85 80.275 105.121 80.275 99.2875C80.275 93.4539 75.5461 88.725 69.7125 88.725C63.8789 88.725 59.15 93.4539 59.15 99.2875C59.15 105.121 63.8789 109.85 69.7125 109.85Z",
    fill: "url(#paint3_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.863 109.85C134.696 109.85 139.425 105.121 139.425 99.2875C139.425 93.4539 134.696 88.725 128.863 88.725C123.029 88.725 118.3 93.4539 118.3 99.2875C118.3 105.121 123.029 109.85 128.863 109.85Z",
    fill: "url(#paint4_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.275 158.438C80.275 164.271 75.5461 169 69.7125 169C63.8789 169 59.15 164.271 59.15 158.438C59.15 152.604 63.8789 147.875 69.7125 147.875C75.5461 147.875 80.275 152.604 80.275 158.438Z",
    fill: "url(#paint5_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7125 80.275C75.5461 80.275 80.275 75.5461 80.275 69.7125C80.275 63.8789 75.5461 59.15 69.7125 59.15C63.8789 59.15 59.15 63.8789 59.15 69.7125C59.15 75.5461 63.8789 80.275 69.7125 80.275Z",
    fill: "url(#paint6_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.425 69.7125C139.425 75.5461 134.696 80.275 128.863 80.275C123.029 80.275 118.3 75.5461 118.3 69.7125C118.3 63.8789 123.029 59.15 128.863 59.15C134.696 59.15 139.425 63.8789 139.425 69.7125Z",
    fill: "url(#paint7_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7125 139.425C75.5461 139.425 80.275 134.696 80.275 128.863C80.275 123.029 75.5461 118.3 69.7125 118.3C63.8789 118.3 59.15 123.029 59.15 128.863C59.15 134.696 63.8789 139.425 69.7125 139.425Z",
    fill: "url(#paint8_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.125 69.7125C21.125 75.5461 16.3961 80.275 10.5625 80.275C4.72888 80.275 0 75.5461 0 69.7125C0 63.8789 4.72888 59.15 10.5625 59.15C16.3961 59.15 21.125 63.8789 21.125 69.7125Z",
    fill: "url(#paint9_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 99.2875C109.85 105.121 105.121 109.85 99.2875 109.85C93.4539 109.85 88.725 105.121 88.725 99.2875C88.725 93.4539 93.4539 88.725 99.2875 88.725C105.121 88.725 109.85 93.4539 109.85 99.2875Z",
    fill: "url(#paint10_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.438 109.85C164.271 109.85 169 105.121 169 99.2875C169 93.4539 164.271 88.725 158.438 88.725C152.604 88.725 147.875 93.4539 147.875 99.2875C147.875 105.121 152.604 109.85 158.438 109.85Z",
    fill: "url(#paint11_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 158.438C109.85 164.271 105.121 169 99.2875 169C93.4539 169 88.725 164.271 88.725 158.438C88.725 152.604 93.4539 147.875 99.2875 147.875C105.121 147.875 109.85 152.604 109.85 158.438Z",
    fill: "url(#paint12_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1375 109.85C45.9711 109.85 50.7 105.121 50.7 99.2875C50.7 93.4539 45.9711 88.725 40.1375 88.725C34.3039 88.725 29.575 93.4539 29.575 99.2875C29.575 105.121 34.3039 109.85 40.1375 109.85Z",
    fill: "url(#paint13_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85 40.1375C109.85 45.9711 105.121 50.7 99.2875 50.7C93.4539 50.7 88.725 45.9711 88.725 40.1375C88.725 34.3039 93.4539 29.575 99.2875 29.575C105.121 29.575 109.85 34.3039 109.85 40.1375Z",
    fill: "url(#paint14_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2875 80.275C105.121 80.275 109.85 75.5461 109.85 69.7125C109.85 63.8789 105.121 59.15 99.2875 59.15C93.4539 59.15 88.725 63.8789 88.725 69.7125C88.725 75.5461 93.4539 80.275 99.2875 80.275Z",
    fill: "url(#paint15_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 69.7125C169 75.5461 164.271 80.275 158.438 80.275C152.604 80.275 147.875 75.5461 147.875 69.7125C147.875 63.8789 152.604 59.15 158.438 59.15C164.271 59.15 169 63.8789 169 69.7125Z",
    fill: "url(#paint16_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2875 139.425C105.121 139.425 109.85 134.696 109.85 128.863C109.85 123.029 105.121 118.3 99.2875 118.3C93.4539 118.3 88.725 123.029 88.725 128.863C88.725 134.696 93.4539 139.425 99.2875 139.425Z",
    fill: "url(#paint17_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7 69.7125C50.7 75.5461 45.9711 80.275 40.1375 80.275C34.3039 80.275 29.575 75.5461 29.575 69.7125C29.575 63.8789 34.3039 59.15 40.1375 59.15C45.9711 59.15 50.7 63.8789 50.7 69.7125Z",
    fill: "url(#paint18_linear_2714_9877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2875 21.125C105.121 21.125 109.85 16.3961 109.85 10.5625C109.85 4.72888 105.121 0 99.2875 0C93.4539 0 88.725 4.72888 88.725 10.5625C88.725 16.3961 93.4539 21.125 99.2875 21.125Z",
    fill: "url(#paint19_linear_2714_9877)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2714_9877",
    x1: 85,
    y1: -71,
    x2: 85,
    y2: 143.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawsatSymbolWithGradient);
export default __webpack_public_path__ + "static/media/lawsat-symbol-with-gradient.6f4df0e112d917cb293c86befe19820f.svg";
export { ForwardRef as ReactComponent };